import { Component, Input, OnInit } from '@angular/core';
import { ChartBaseDirective } from '@client/app/modules/charts/directives/chart-base.directive';
import { DEFAULT_CHART_SETTINGS } from '@client/app/modules/charts/constants/Chart.constant';
import { LegendCursorService } from '@client/app/modules/charts/services/LegendCursor.service';

@Component({
    selector: 'mon-chart-bubble',
    templateUrl: './bubble.component.html',
    standalone: true,
    imports: [
        ChartBaseDirective,
    ],
})
export class BubbleComponent implements OnInit {
    @Input() height: any = DEFAULT_CHART_SETTINGS.CHART.HEIGHT.toString();
    @Input() data: any[] = [];
    @Input() labels: any[] = [];
    @Input() series: any[] = [];
    @Input() options: any = {};
    @Input() override: any[] = [];
    @Input() colors: any[] = [];

    constructor (private legendCursorService: LegendCursorService) {}

    ngOnInit (): void {
        this.height = this.height || DEFAULT_CHART_SETTINGS.CHART.HEIGHT.toString();
        this.options = this.legendCursorService.setHoverState(this.options);
    }
}
